import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  SyncOutlined,
} from '@ant-design/icons';

interface InvoiceStatusBadgeProps {
  status: 'draft' | 'issued' | 'paid' | 'overdue' | 'cancelled' | 'refunded';
  paymentStatus?: 'unpaid' | 'partial' | 'paid' | 'refunded';
  size?: 'small' | 'default';
}

const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({
  status,
  paymentStatus,
  size = 'default'
}) => {
  // Configuration des statuts de facture
  const statusConfig: Record<string, {
    color: string;
    icon: React.ReactNode;
    label: string;
    textColor?: string;
  }> = {
    draft: {
      color: 'default',
      icon: <EditOutlined />,
      label: 'Brouillon',
    },
    issued: {
      color: 'processing',
      icon: <ClockCircleOutlined />,
      label: 'Émise',
    },
    paid: {
      color: 'success',
      icon: <CheckCircleOutlined />,
      label: 'Payée',
    },
    overdue: {
      color: 'error',
      icon: <ExclamationCircleOutlined />,
      label: 'En retard',
    },
    cancelled: {
      color: 'default',
      icon: <CloseCircleOutlined />,
      label: 'Annulée',
    },
    refunded: {
      color: 'warning',
      icon: <SyncOutlined />,
      label: 'Remboursée',
    },
  };

  // Configuration des statuts de paiement (optionnel)
  const paymentStatusConfig: Record<string, {
    color: string;
    label: string;
  }> = {
    unpaid: {
      color: 'default',
      label: 'Non payée',
    },
    partial: {
      color: 'warning',
      label: 'Partiellement payée',
    },
    paid: {
      color: 'success',
      label: 'Payée',
    },
    refunded: {
      color: 'orange',
      label: 'Remboursée',
    },
  };

  const config = statusConfig[status] || statusConfig.issued;

  // Si un statut de paiement est fourni, l'utiliser à la place
  if (paymentStatus && paymentStatus !== 'paid' && status !== 'cancelled') {
    const paymentConfig = paymentStatusConfig[paymentStatus];
    if (paymentConfig) {
      return (
        <Tag
          color={paymentConfig.color}
          icon={config.icon}
          style={{
            fontSize: size === 'small' ? '11px' : '12px',
            padding: size === 'small' ? '0 7px' : '2px 10px',
          }}
        >
          {paymentConfig.label}
        </Tag>
      );
    }
  }

  return (
    <Tag
      color={config.color}
      icon={config.icon}
      style={{
        fontSize: size === 'small' ? '11px' : '12px',
        padding: size === 'small' ? '0 7px' : '2px 10px',
      }}
    >
      {config.label}
    </Tag>
  );
};

export default InvoiceStatusBadge;